module.exports = __webpack_public_path__ + "static/media/whatsapp-brands.5c2e4a53.svg";